(function () {
  'use strict';

  if (window.__morldoroDesktopStageSync) return;
  window.__morldoroDesktopStageSync = true;

  var ARTBOARD_WIDTH = 1920;
  var HERO_HEIGHT = 900;
  var DESKTOP_MIN = 768;

  /* Figma 692:234 — Hero safe vertical bounds (px, unscaled artboard) */
  var HERO_HEADER_TOP = 66;
  var HERO_CTA_TOP = 647;
  var HERO_CTA_BOTTOM = 704;

  function getViewportWidth() {
    return document.documentElement.clientWidth;
  }

  function getViewportHeight() {
    return window.innerHeight;
  }

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  /**
   * Hero-derived global scale.
   * Fit vertically when possible, but never below width-cover floor:
   *   S = max(min(1, viewportHeight / 900), viewportWidth / 1920)
   * Cap S at 1 for viewports <= 1920 (never upscale native artboard).
   */
  function computeGlobalDesktopStage(viewportWidth, viewportHeight) {
    var heightFitScale = Math.min(1, viewportHeight / HERO_HEIGHT);
    var widthCoverScale = viewportWidth / ARTBOARD_WIDTH;
    var scale = Math.max(heightFitScale, widthCoverScale);

    if (viewportWidth <= ARTBOARD_WIDTH) {
      scale = Math.min(scale, 1);
    }
    var logicalVisibleWidth = viewportWidth / scale;
    var logicalLeft = (ARTBOARD_WIDTH - logicalVisibleWidth) / 2;

    return {
      scale: scale,
      logicalLeft: logicalLeft,
      logicalVisibleWidth: logicalVisibleWidth,
      heightFitScale: heightFitScale,
      widthCoverScale: widthCoverScale,
    };
  }

  /**
   * Hero vertical crop — top-anchored, bottom-clipped.
   * Keeps Figma Y=0 at the viewport top (cropTop = 0) whenever possible so
   * header breathing room (Y=66) stays at ~66*S px physically.
   * Only shifts down minimally when the CTA would otherwise be clipped.
   */
  function computeHeroCrop(viewportHeight, scale) {
    var renderedHeight = HERO_HEIGHT * scale;

    if (renderedHeight <= viewportHeight) {
      return {
        cropTop: 0,
        viewportHeight: renderedHeight,
        verticalOverflow: 0,
      };
    }

    var visibleLogicalHeight = viewportHeight / scale;
    var maxCropTop = HERO_HEIGHT - visibleLogicalHeight;
    var cropTop = 0;

    if (visibleLogicalHeight < HERO_CTA_BOTTOM) {
      cropTop = HERO_CTA_BOTTOM - visibleLogicalHeight;
      cropTop = clamp(cropTop, 0, maxCropTop);
    }

    return {
      cropTop: cropTop,
      viewportHeight: viewportHeight,
      verticalOverflow: renderedHeight - viewportHeight,
    };
  }

  function clearCanvasInlineStageStyles(canvas) {
    canvas.style.transform = '';
    canvas.style.left = '';
    canvas.style.top = '';
    canvas.style.transformOrigin = '';
    canvas.style.width = '';
  }

  function setScaledHeight(element, logicalHeight, scale) {
    element.style.height = Math.ceil(logicalHeight * scale * 100) / 100 + 'px';
  }

  function syncHeroStage(stage, heroCrop) {
    var heroViewport = document.querySelector('.hero-desktop__viewport');
    var heroCanvas = document.querySelector('.hero-desktop__canvas');
    if (!heroViewport || !heroCanvas) {
      return;
    }

    clearCanvasInlineStageStyles(heroCanvas);
    heroCanvas.style.height = HERO_HEIGHT + 'px';
    heroViewport.style.height = Math.ceil(heroCrop.viewportHeight * 100) / 100 + 'px';
  }

  function syncFollowerStages(scale) {
    document.querySelectorAll('[data-desktop-stage-height]').forEach(function (outer) {
      var artboardHeight = parseInt(outer.getAttribute('data-desktop-stage-height'), 10);
      if (!Number.isFinite(artboardHeight) || artboardHeight <= 0) {
        return;
      }

      var viewport = outer.querySelector('.desktop-stage-follower__viewport');
      var canvas = outer.querySelector('.desktop-stage-follower__canvas');
      if (!viewport || !canvas) {
        return;
      }

      clearCanvasInlineStageStyles(canvas);

      var canvasHeight = artboardHeight;
      if (outer.hasAttribute('data-desktop-stage-expanded-height')) {
        var expandedHeight = parseInt(
          outer.getAttribute('data-desktop-stage-expanded-height'),
          10
        );
        if (Number.isFinite(expandedHeight) && expandedHeight > artboardHeight) {
          canvasHeight = expandedHeight;
        }
      }

      canvas.style.height = canvasHeight + 'px';
      setScaledHeight(viewport, canvasHeight, scale);
    });
  }

  function resetDesktopStages() {
    document.documentElement.style.removeProperty('--desktop-stage-scale');
    document.documentElement.style.removeProperty('--desktop-stage-logical-left');
    document.documentElement.style.removeProperty('--desktop-stage-hero-crop-top');

    var heroViewport = document.querySelector('.hero-desktop__viewport');
    var heroCanvas = document.querySelector('.hero-desktop__canvas');
    if (heroViewport) {
      heroViewport.style.height = '';
    }
    if (heroCanvas) {
      heroCanvas.style.height = '';
      clearCanvasInlineStageStyles(heroCanvas);
    }

    document.querySelectorAll('[data-desktop-stage-height]').forEach(function (outer) {
      var viewport = outer.querySelector('.desktop-stage-follower__viewport');
      var canvas = outer.querySelector('.desktop-stage-follower__canvas');
      if (!viewport || !canvas) {
        return;
      }

      viewport.style.height = '';
      canvas.style.height = '';
      clearCanvasInlineStageStyles(canvas);
    });
  }

  function applyGlobalDesktopStage(stage, heroCrop) {
    document.documentElement.style.setProperty('--desktop-stage-scale', String(stage.scale));
    document.documentElement.style.setProperty(
      '--desktop-stage-logical-left',
      String(stage.logicalLeft)
    );
    document.documentElement.style.setProperty(
      '--desktop-stage-hero-crop-top',
      String(heroCrop.cropTop)
    );
    syncHeroStage(stage, heroCrop);
    syncFollowerStages(stage.scale);
  }

  function isOverlayScrollLockActive() {
    var root = document.documentElement;
    var body = document.body;

    return (
      root.classList.contains('custom-cart-open') ||
      body.classList.contains('custom-cart-open') ||
      root.classList.contains('support-popup-open') ||
      body.classList.contains('support-popup-open')
    );
  }

  function syncDesktopStages() {
    var viewportWidth = getViewportWidth();
    var viewportHeight = getViewportHeight();

    if (viewportWidth < DESKTOP_MIN) {
      resetDesktopStages();
      return;
    }

    if (isOverlayScrollLockActive()) {
      return;
    }

    var stage = computeGlobalDesktopStage(viewportWidth, viewportHeight);
    var heroCrop = computeHeroCrop(viewportHeight, stage.scale);
    applyGlobalDesktopStage(stage, heroCrop);
  }

  function scheduleSync() {
    window.requestAnimationFrame(syncDesktopStages);
  }

  syncDesktopStages();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSync);
  } else {
    scheduleSync();
  }

  window.addEventListener('load', scheduleSync, { passive: true });
  window.addEventListener('resize', scheduleSync, { passive: true });
  window.addEventListener('orientationchange', scheduleSync, { passive: true });

  if (typeof ResizeObserver !== 'undefined') {
    var resizeObserver = new ResizeObserver(scheduleSync);
    resizeObserver.observe(document.documentElement);
  }

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(scheduleSync).catch(function () {});
  }
})();
